<template>
    <div v-bind="$attrs"
         :class="['columns', {['is-' + gap]: true, 'is-mobile': isMobile, 'is-desktop': !isTablet, ' is-multiline': isMultiLine}]">
        <slot></slot>
    </div>
</template>

<script>
  export default {
    name: "GridRow",
    props: {
      isMobile: {
        // if true the columns will not stack for mobile, but remain side by side
        type: Boolean,
        default: false,
      },
      isTablet: {
        // if true the columns will not stack for Tablet, but will remain side by side
        type: Boolean,
        default: true,
      },
      isMultiLine: {
        // if true the columns will wrap when they exceed 12 other wise they will overflow the grid.
        type: Boolean,
        default: true,
      },
      /**
       * Note: This size should be 0-8
       */
      gap: {
        type: Number,
        default: 3,
      }
    }
  }
</script>

<style scoped>

</style>
